<template>
  <v-btn v-if="canSyncContacts"
         :disabled="syncing"
         class="mr-2"
         @click.prevent="syncFromCRM"
         small>
    <template v-if="syncing">
      <v-icon left>
        fal fa-spin fa-spinner
      </v-icon>
      Syncing
    </template>
    <template v-else>
      Sync from {{ crmLabel }}
    </template>
  </v-btn>
</template>
<script>
import {isObject} from 'lodash';
import {mapGetters} from 'vuex';
import echo from '../../../plugins/echo';
import userContactService from '../../../services/userContactService';
import moment from 'moment-timezone';
import DOMPurify from 'dompurify';

export default {
  name: 'sync-user-contacts-button',
  data() {
    return {
      syncing: false,
    }
  },
  created() {
    this.initEcho();
  },
  computed: {
    ...mapGetters([
      'canSyncContacts', // MLD-2598
      'crmLabel', // MLD-2598
      'team',
      'user',
    ]),
  },
  methods: {
    initEcho() {
      if (!isObject(echo)) {
        return;
      }
      echo.private(this.user.channel) // MLD-2598
        .listen('CRM.UserContactsImported', e => {
          //console.log('CRM.UserContactsImported', e);
          this.syncing = false;
          if (e.success) {
            this.$toast.success(DOMPurify.sanitize(e.message));
          } else {
            this.$toast.error(DOMPurify.sanitize(e.message));
          }
          this.$emit('updated');
        });
    },
    syncFromCRM() { // MLD-2598
      if (this.syncing) {
        return;
      }
      this.syncing = true;
      const startAt = moment().subtract(2, 'day').format('YYYY-MM-DD');
      //console.log(`userContactService.syncFromCRM() START`, startAt);
      userContactService.syncFromCRM(this.user.id, startAt)
        .then(() => {
          //console.log(`userContactService.syncFromCRM() END`, startAt);
        })
        .catch(err => {
          if (err.response && err.response.data) {
            this.$toast.error(`There was a problem syncing your contacts: ${DOMPurify.sanitize(err.response.data.message)}.`);
          } else {
            this.$toast.error('There was a problem syncing your contacts.');
          }
          this.syncing = false;
        });
    },
  }
}
</script>
